module.exports = __webpack_public_path__ + "static/news-photo-5d171ed5ab69054342007dc1cf0de7d3.jpg";